const faqData = [
  {
    q: '桃子影院的影片需要付费吗？',
    a: '完全不需要！桃子影院所有电影大全中的影片均为永久免费在线观看，不设任何付费墙或会员门槛，打开即看，真正做到零成本观影。',
  },
  {
    q: '播放会卡顿吗？支持什么清晰度？',
    a: '我们采用先进的CDN加速与智能缓冲技术，确保影片秒开不缓冲。支持从高清、超清、蓝光到4K多档清晰度自由切换，根据网络状况自动适配最佳画质。',
  },
  {
    q: '最新电影多久能上线？',
    a: '桃子影院拥有高效的片源更新团队，热门电影上映后通常在7-15天内即可上线高清版本。每日凌晨自动更新片库，最新电影、热门电影排行榜实时同步。',
  },
  {
    q: '支持手机和平板观看吗？',
    a: '当然支持！桃子影院采用响应式设计，完美适配手机、平板、电脑等所有设备。无论是在家用大屏还是通勤路上用手机，都能享受流畅的高清观影体验。',
  },
  {
    q: '有华语电影专区吗？',
    a: '华语电影是桃子影院的特色板块之一，涵盖经典港片、内地院线大片、独立文艺电影以及最新上线的华语新片，分类清晰，检索便捷。',
  },
  {
    q: '如何找到想看的电影？',
    a: '您可以通过首页的热播排行榜发现热门内容，在专题合集中按类型浏览，或使用搜索功能直接查找。我们还提供热门话题标签帮助您快速定位感兴趣的影片。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">常见问题</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">关于桃子影院的观影方式，您想知道的都在这里</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/40"
            >
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 mb-2 flex items-start gap-2">
                <span className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center rounded bg-primary-500/15 text-primary-400 text-[10px] font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-300 leading-relaxed pl-7 md:pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}